import { Socket, Manager } from "socket.io-client";
import { Partner } from "../../domain/entities/Partner";
import { apiServices } from "../../../../core/utilities/ApiServices";
import { PartnerPending } from "../../domain/entities/partnerPending";

export interface PartnerSocketDataSource {
    connectPartnerSocket(): Promise<void>;
    disconnectPartnerSocket(): Promise<void>;
    getPendingPartners(): Promise<PartnerPending[]>;
    deleteCurrentPartner(user_id: string): Promise<void>;
    cancelInvitationPartner(user_id: string): Promise<void>;
    sendInvitationPartner(id: string,user_id: string, match_id: string): Promise<void>;
    responseInvitation(user_id: string, partner_response: boolean): Promise<void>;
    getNotificationsPartner(callback: (data: PartnerPending) => void): void;
    getSocket(): Socket | null;
    getNotificationsPartnerResponse(callback: (data:any) => void): void;
   
    listenPartnerInvited(callback: (data: Partner) => void): void;
}

export class PartnerSocketDataSourceImpl implements PartnerSocketDataSource {

    private socket: Socket | null = null;
    private getNotificationsPartnerCallback: ((data: PartnerPending) => void) | null = null;

    private getNotificationsPartnerResponseCallback:
        | ((data:any) => void)
        | null = null;

    private onPartnerInvitedCallback: ((data: Partner) => void) | null = null;

    async connectPartnerSocket(): Promise<void> {
        const token = localStorage.getItem("userToken");
        if (!token) {
            throw new Error("No se encontró el token");
        }

        const manager = new Manager(
            `${process.env.REACT_APP_UNJABBED}/socket.io/socket.io.js`,
            {
                transports: ["websocket"],
                extraHeaders: {
                    authorization: `Bearer ${token}`,
                },
            }
        );

        this.socket = manager.socket("/partner", { auth: { token } });
        this.socket.connect();

        this.socket.on("notification_partner", (data: PartnerPending) => {
            this.getNotificationsPartnerCallback?.(data);
        });
        
        this.socket.on("partner-notification-response", (data:any) => {
            this.getNotificationsPartnerResponseCallback?.(data);
        });

        this.socket.on("partner_invited", (data: Partner) => {
            this.onPartnerInvitedCallback?.(data);
        });
    }

    async disconnectPartnerSocket(): Promise<void> {
        if (this.socket) {
            this.socket.off("notification_partner");
            this.socket.off("partner-notification-response");
            this.socket.off("partner_invited");
            this.socket.disconnect();
            this.socket = null;
            this.getNotificationsPartnerCallback = null;
            this.getNotificationsPartnerResponseCallback = null;
            this.onPartnerInvitedCallback = null;
        }
    }

    getSocket(): Socket | null {
        return this.socket;
    }

    async getPendingPartners(): Promise<PartnerPending[]> {
        const response = await apiServices.get(`/profile/partner`);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error("Error fetching partners");
        }
    }
    
    async deleteCurrentPartner(user_id: string): Promise<void> {
        const response = await apiServices.delete(`/profile/partner`,{params:{user_id}});
        if (response.status !== 200) {
            throw new Error("Error deleting partner");
        }
    }    

    async cancelInvitationPartner(user_id: string): Promise<void> {
        const response = await apiServices.delete(`/profile/cancel-invitation-partner`,{params: {user_id}});
        if (response.status !== 200) {
            throw new Error("Error canceling partner");
        }
    }

    async sendInvitationPartner(id: string,user_id: string, match_id: string): Promise<void> {
        if (!this.socket) {
            throw new Error("Socket no está conectado.");
        }

        return new Promise((resolve, reject) => {
            this.socket!.emit("partner", { id,user_id, match_id }, (response: any) => {
                if (response.error) {
                    reject(new Error("Error al emitir solicitud de partner"));
                } else {
                    resolve(response.data);
                }
            });
        });
    }

    async responseInvitation(user_id: string, partner_response: boolean): Promise<void> {
        if (!this.socket) {
            throw new Error("Socket no está conectado.");
        }

        return new Promise((resolve, reject) => {
            this.socket!.emit("partner-response", { user_id, partner_response }, (response: any) => {
                if (response.error) {
                    reject(new Error("Error al emitir respuesta de partner"));
                } else {
                    resolve(response.data);
                }
            });
        });
    }

    getNotificationsPartner(callback: (data: PartnerPending) => void): void{
        this.getNotificationsPartnerCallback = callback;
    }

    getNotificationsPartnerResponse(
        callback: (data:any) => void
    ): void {
        this.getNotificationsPartnerResponseCallback = callback;
    }

    listenPartnerInvited(callback: (data: Partner) => void): void {
        this.onPartnerInvitedCallback = callback;
    }
}
